import { render } from "./ContactSupport.vue?vue&type=template&id=5bb2e967"
import script from "./ContactSupport.vue?vue&type=script&lang=js"
export * from "./ContactSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__